// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChartDonutBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M17.219 2.51A2.5 2.5 0 0 0 14.5 5v5.084a2.479 2.479 0 0 0 2.075 2.462 3.5 3.5 0 1 1-3.067 5.898 3.537 3.537 0 0 1-1.008-2.26c-.046-.91.133-1.657.534-2.217a2.485 2.485 0 0 0-.267-3.205l-3.44-3.52-.012-.01a2.5 2.5 0 0 0-3.69.17 13.453 13.453 0 0 0 .896 18.21A13.401 13.401 0 0 0 16 29.5h.194A13.54 13.54 0 0 0 29.5 16.191c.096-7.046-5.297-13.056-12.281-13.681ZM7.586 9.75l2.774 2.832a5.97 5.97 0 0 0-.725 1.918H5.609c.246-1.725.926-3.36 1.977-4.75ZM5.607 17.5h4.067a6.5 6.5 0 0 0 4.826 4.825v4.069A10.5 10.5 0 0 1 5.607 17.5ZM17.5 26.389v-4.061a6.44 6.44 0 0 0 2.933-1.578A6.5 6.5 0 0 0 17.5 9.674V5.563c5.161.74 9.073 5.287 9 10.587-.073 5.17-4 9.506-9 10.239Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
